import { z } from 'zod';
import { requiredString } from '../helpers';
export const AMS360_Get_Policies_By_Number_1_ConfigValidator = z.object({
    ams360Connection: requiredString('AMS360 Connection is required'),
    policyNumber: requiredString('Policy Number is required')
});
//# sourceMappingURL=ams360-get-policies-by-number-1.js.map